import { NAVIGATION_RECEIVE, NAVIGATION_TOGGLE } from '../Actions/Navigation.action';

export const navigation = (state = { menu:[], mobileOpen: false }, action) => {
    switch (action.type) {
        case NAVIGATION_RECEIVE:
        case NAVIGATION_TOGGLE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}